import axios from 'axios';

export const ACADEMIC_SESSIONS = 'v3/academic_sessions';

export function getAcademicSessions(params) {
  return axios.get(`${ACADEMIC_SESSIONS}`, { params });
}
